// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage } from "react-intl";

export const DeleteCta = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.dropdownMenu.deleteCta"
        description="Delete cta."
        defaultMessage="Delete"
    />
);
DeleteCta.displayName = "DeleteCta";

export const CancelCta = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.dropdownMenu.cancelCta"
        description="Cancel cta."
        defaultMessage="Cancel"
    />
);
CancelCta.displayName = "CancelCta";

export const DeleteConfirmation = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.dropdownMenu.deleteConfirmation"
        description="Delete confirmation."
        defaultMessage="Delete API?"
    />
);
DeleteConfirmation.displayName = "DeleteConfirmation";

export const DeleteConfirmationMesage = (props: { name: ReactNode; id: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.dropdownMenu.deleteConfirmationMesage"
        description="Delete confirmation mesage."
        defaultMessage="Are you sure you want to delete API {name} ({id})?"
        values={props}
    />
);
DeleteConfirmationMesage.displayName = "DeleteConfirmationMesage";
